import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { ManifestoEmbarquePainelService } from 'src/app/services/manifesto-embarque-painel.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalSolicitacaoProrrogacaoSlaComponent } from './modal-solicitacao-prorrogacao-sla/modal-solicitacao-prorrogacao-sla.component';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';
import { ModalManifestoEmbarquePainelDetalheComponent, PaginacaoComponent } from 'src/app/@shared/components';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-manifesto-embarque-painel',
  templateUrl: './manifesto-embarque-painel.component.html',
  styleUrls: ['./manifesto-embarque-painel.component.scss']
})
export class ManifestoEmbarquePainelComponent implements OnInit {
  habilitarProrrogacao = false;
  habilitarProrrogacaoPainelME = false;
  featureId;

  isLoading = false;
  isLoadingCards = false;


  public initialTime = true;
  public error = {} as any;
  public isMobile: boolean;
  public paging = { index: 0, size: 10, length: 0 };
  public panelCollection: MatTableDataSource<any> = new MatTableDataSource<any>();
  public colorScheme: any = {
    domain: ['#fbff14', '#d7df23', '#0cc760', '#fca212', '#20853c', '#cf0a14']
  };
  public cardsFilter = {
    totalPendentes: false,
    totalBaixados: false,
    naoExpiradosSemRessalva: false,
    naoExpiradosComRessalva: false,
    expiradosSemRessalva: false,
    expiradosComRessalva: false,
  };
  public view: [number, number] = [1800, 180];
  public cardColor: string = '#fefefe';
  public cards: any;
  public panelForm: FormGroup = new FormGroup({
    manifestoEmbarqueId: new FormControl(),
    dataInicial: new FormControl(),
    dataFinal: new FormControl(),
    codigoBarras: new FormControl(),
    flgTipoSituacao: new FormControl({ value: '1', disabled: false })
  });

  get manifestoEmbarqueId() { return this.panelForm.get('manifestoEmbarqueId').value; }
  get dataInicial() { return this.panelForm.get('dataInicial').value; }
  get flgTipoSituacao() { return this.panelForm.get('flgTipoSituacao').value; }
  get dataFinal() { return this.panelForm.get('dataFinal').value; }
  get codigoBarras() { return this.panelForm.get('codigoBarras').value; }

  public displayedColumns: string[] = [
    'acao',
    'dtCriacao',
    'filialOrigem',
    'manifestoEmbarqueId',
    'agente',
    'volume',
    'valor',
    'motorista',
    'placa',
    'tipoSituacaoManifestoEmbarque',
    'dtBaixa',
    'usuarioBaixa',
    'dtVencRessalva',
    'qtdRessalvas',
    'stProrrogSLA'
  ];
  @ViewChild(PaginacaoComponent, { static: false }) paginator: PaginacaoComponent;
  constructor(
    private service: ManifestoEmbarquePainelService,
    public router: Router,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public authService: AuthService
  ) {
    if (!this.featureId) { this.featureId = 'transferencias.manifesto-embarque.painel-manifesto-embarque' }
  }

  ngOnInit() {
    this.authService.checkFeature(`${this.featureId}.habilita-prorrogacao`).subscribe(temPermissao => {
      if (temPermissao === true) this.habilitarProrrogacao = true;
    });

    //Paineis >
    this.authService.checkFeature(`paineis.manifesto-embarque.painel-manifesto-embarque.habilita-prorrogacao`).subscribe(temPermissao => {
      if (temPermissao === true) this.habilitarProrrogacaoPainelME = true;
    });

    this.initDateTimeFilter();
    this.isMobile = detectar_mobile();
  }

  public search(shouldResetPagination: boolean = true) {

    if (this.codigoBarras && this.codigoBarras != null && ((Number(this.codigoBarras) && Number.parseInt(this.codigoBarras) > 2147483647) || (Number(this.codigoBarras) && !Number.isSafeInteger(Number.parseInt(this.codigoBarras))))) {
      this.openSnackBar('Inteiro maior do que o permitido!', 'OK', 5000, 'warning-snackbar');
      return;
    }

    if (this.dataInicial && this.dataFinal && (this.dataFinal < this.dataInicial)) {
      this.openSnackBar('Por favor informe um período de busca válido!', 'OK', 9000);
      return;
    }

    if ((!this.dataInicial && !this.manifestoEmbarqueId) || (!this.dataFinal && !this.manifestoEmbarqueId) || (!this.manifestoEmbarqueId && !this.dataFinal && !this.dataInicial) || (!this.manifestoEmbarqueId && (Date.parse(this.dataFinal) - Date.parse(this.dataInicial)) / 1000 / 60 / 60 > 168)) {
      this.openSnackBar('Por favor informe um manifesto de embarque ou estreite o período de busca para no máximo 7 dias!', 'OK', 9000);
      return;
    }

    if (this.initialTime === true && this.flgTipoSituacao != 2)
      this.cardsFilter.totalPendentes = true;

    let tipoSituacaoManifestoEmbarqueId;
    if (this.cardsFilter.totalPendentes === true)
      tipoSituacaoManifestoEmbarqueId = 1;
    else if (this.cardsFilter.totalBaixados === true)
      tipoSituacaoManifestoEmbarqueId = 2;
    else if (this.cardsFilter.naoExpiradosSemRessalva === true)
      tipoSituacaoManifestoEmbarqueId = 3;
    else if (this.cardsFilter.naoExpiradosComRessalva === true)
      tipoSituacaoManifestoEmbarqueId = 4;
    else if (this.cardsFilter.expiradosSemRessalva === true)
      tipoSituacaoManifestoEmbarqueId = 5;
    else if (this.cardsFilter.expiradosComRessalva === true)
      tipoSituacaoManifestoEmbarqueId = 6;

    this.resetOrNotPagination(shouldResetPagination);
    this.isLoading = true;
    this.panelCollection.data = null;
    const input = {
      dataInicial: this.dataInicial ? new Date(this.dataInicial).toISOString().split('T')[0] : null,
      dataFinal: this.dataFinal ? new Date(this.dataFinal).toISOString().split('T')[0] : null,
      manifestoEmbarqueId: this.manifestoEmbarqueId,
      tipoSituacaoManifestoEmbarqueId: tipoSituacaoManifestoEmbarqueId,
      tipoSituacaoVisualizacaoId: this.flgTipoSituacao,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size,
      codigoBarras: this.codigoBarras,
    } as any;

    this.service.getMEContadoresPainel(input)
      .pipe(take(1))
      .subscribe(response => {
        this.cards = response.body;
        Object.assign(this, { cards: this.cards });
        this.updateCardsColors();
        this.setDefaultSelected();
        this.initialTime = false;
        this.isLoadingCards = false
        this.changeCursorCards();
      },
        () => {
          this.isLoading = false;
          this.isLoadingCards = false
          this.changeCursorCards();
          this.openSnackBar('Erro ao carregar listagem!', 'OK', 5000, 'danger-snackbar');
          this.initialTime = false;
        });

    this.service.getAll(input)
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {

          this.panelCollection.data = response.body;
          console.log('--->', JSON.stringify(response.body))
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem!', 'OK', 5000, 'danger-snackbar');
        });
  }

  private setDefaultSelected() {
    if (this.cardsFilter.totalPendentes === true)
      setTimeout(() => this.updateSelected({ extra: "totalPendentes" }), 100);
    else if (this.cardsFilter.totalBaixados === true)
      setTimeout(() => this.updateSelected({ extra: "totalBaixados" }), 100);
  }

  public toggleCards(event) {
    if(!this.isLoading){
      this.isLoadingCards = true
      this.updateSelected(event);
      this.search();
    }
  }

  public updateSelected(event) {
    this.resetCardsFilterSelecteds(event);

    if (this.cards) {
      for (let index = 0; index < this.cards.length; index++) {
        let object = this.cards[index];
        const element = document.querySelectorAll("[ngx-charts-card]")[index];
        this.changeCursorCards(element);
        var checked = this.cardsFilter[object.extra];
        if (checked) {
          (<any>(element.childNodes[0].childNodes[0])).style.removeProperty("stroke-dasharray");
          (<any>(element.childNodes[0].childNodes[0])).style.setProperty("stroke", "#495057");
          (<any>(element.childNodes[0].childNodes[0])).style.setProperty("stroke-width", "5px");
        }
        else {
          (<any>(element.childNodes[0].childNodes[0])).style.removeProperty("stroke");
          (<any>(element.childNodes[0].childNodes[0])).style.removeProperty("stroke-width");
        }
      }
    }
  }

  public updateCardsFlags() {
    if (this.flgTipoSituacao == 0) {
      this.cardsFilter.totalPendentes = true;
      this.cardsFilter.totalBaixados = false;
    }
    else if (this.flgTipoSituacao == 1) {
      this.cardsFilter.totalPendentes = true;
      this.cardsFilter.totalBaixados = false;
    }
    else if (this.flgTipoSituacao == 2) {
      this.cardsFilter.totalBaixados = true;
      this.cardsFilter.totalPendentes = false;
    }

    // this.search();
  }

  public updateCardsColors() {
    if (this.flgTipoSituacao == 0) {
      this.view = [1800, 180];
      this.colorScheme = {
        domain: ['#fbff14', '#d7df23', '#0cc760', '#fca212', '#20853c', '#cf0a14']
      };
    }
    else if (this.flgTipoSituacao == 1) {
      this.view = [320, 180];
      this.colorScheme = {
        domain: ['#fbff14']
      };
    }
    else if (this.flgTipoSituacao == 2) {
      this.view = [1800, 180];
      this.colorScheme = {
        domain: ['#d7df23', '#0cc760', '#fca212', '#20853c', '#cf0a14']
      };
    }
    // this.search();
  }

  private resetOrNotPagination(shouldResetPagination) {
    if (shouldResetPagination === true) {
      if (this.paginator)
        this.paginator.goTo = 1;
      this.paging.index = 0;
    }
  }

  private resetCardsFilterSelecteds(event: any) {
    this.cardsFilter.expiradosComRessalva = false;
    this.cardsFilter.expiradosSemRessalva = false;
    this.cardsFilter.naoExpiradosComRessalva = false;
    this.cardsFilter.naoExpiradosSemRessalva = false;
    this.cardsFilter.totalBaixados = false;
    this.cardsFilter.totalPendentes = false;
    this.cardsFilter[event.extra] = true;
  }

  public onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.search(false);
  }

  public onChangeEvent() {
    this.error = {} as any;
  }

  public initDateTimeFilter() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 7);
    this.panelForm.get("dataInicial").setValue(filtroInicio);
    this.panelForm.get("dataFinal").setValue(filtroFim);
  }

  public clearFields() {
    this.panelForm.reset();
    this.paging.index = 0;
    this.panelCollection = new MatTableDataSource<any>()
    this.initDateTimeFilter();
    this.panelForm.get('flgTipoSituacao').setValue('1');
    this.cards = [];
  }

  public openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  public openModalMEDetalhe(item): void {
    const modalReference = this.dialog.open(ModalManifestoEmbarquePainelDetalheComponent, {
      width: '1240px',
      data: { item: { agenteId: item.agenteId, manifestoEmbarqueId: item.manifestoEmbarqueId, baixado: item.tipoSituacaoManifestoEmbarqueId === 2, } }
    });

    modalReference.afterClosed().pipe(take(1)).subscribe(() => {
      // this.search();
    });
  }

  public solicitarAumento(item: any) {
    console.log('--->', JSON.stringify(item));

    const modalReference = this.dialog.open(ModalSolicitacaoProrrogacaoSlaComponent, {
      width: "650px",
      data: {
        item: {
          item: item,
        },
      },
    });
    modalReference
      .afterClosed()
      .pipe(take(1))
      .subscribe((response) => {
        if (response) {
          this.search();
        }
      });
  }

  private changeCursorCards(element = null) {
    if (element) {
      if (this.isLoadingCards) {
        (<any>(element.childNodes[0].childNodes[0])).style.cursor = "progress";
      } else {
        (<any>(element.childNodes[0].childNodes[0])).style.cursor = "pointer";
      }

    } else {
      if(this.cards){
        for (let index = 0; index < this.cards.length; index++) {
          const element = document.querySelectorAll("[ngx-charts-card]")[index];

          if (this.isLoadingCards) {
            (<any>(element.childNodes[0].childNodes[0])).style.cursor = "progress";
          } else {
            (<any>(element.childNodes[0].childNodes[0])).style.cursor = "pointer";
          }
        }
      }
    }
  }
}
